import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
// mui
import { Box, Button, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Unstable_Grid2';
// component
// api
import { resEvmTxDataProps } from '@/api/evmScan/txList';
// lib
import { unixToDate } from '@/lib/days';
import { weiToEther } from '@/lib/ether/parseValue';
import theme from '@/theme';
import { ResTxHistoryProps } from '@/types';

export default function TxList({ list, symbol, addr }: { list: ResTxHistoryProps[]; symbol: string; addr: string }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1 }} height="100%">
      <Typography variant="h5" fontWeight={400} textAlign={'center'}>
        {symbol}
      </Typography>
      <Box mb={2} />
      {list.map((item: ResTxHistoryProps) => (
        <Fragment key={item.hash}>
          <Grid
            container
            spacing={1}
            onClick={() => {
              navigate('/txHistory', {
                state: {
                  data: item,
                  symbol,
                  addr,
                },
              });
            }}
          >
            <Grid xs>
              {item.from.toLowerCase() === String(addr).toLowerCase() ? '보내기' : '받기'} <br />
              {item.timeStamp}
            </Grid>
            <Grid xs={2}></Grid>
            <Grid
              xs
              sx={{
                color: theme.palette.primary.main,
                fontWeight: 700,
                textAlign: 'right',
              }}
            >
              <br />
              {item.value} {symbol}
            </Grid>
          </Grid>
          <Divider sx={{ my: 3.5 }} />
        </Fragment>
      ))}
    </Box>
  );
}
